<template>
  <div>
    <AppDrawer v-model="open" :title="t('me.transfer')" padded @back="closeTransfer">
      <TransferAutoSwitch
        :model-value="auto"
        :disabled="settingsBusy"
        @update:model-value="toggleAuto"
      />

      <div v-if="listPending && !venue" class="tf-loading">
        {{ t('me.tfLoading') }}
      </div>

      <TransferSwapCard
        v-else-if="venue"
        class="mt12"
        :dir="dir"
        :venue="venue"
        :central-avail="centralAvail"
        :main-acct="mainAcctLabel"
        :format-central="formatCentral"
        :format-venue-amt="formatVenueAmt"
        @swap="swapDir"
        @open-venue="sheetOpen = true"
      />

      <div v-else class="tf-loading">{{ t('me.tfEmptyVenue') }}</div>

      <TransferAmountBox v-model="amount" class="mt12" :sym="amountSym" @pct="setPct" />

      <div v-if="err" class="tf-err">{{ err }}</div>

      <button
        type="button"
        class="btn btn-primary btn-block mt16"
        :disabled="busy || listPending || !venue"
        @click="submit"
      >
        {{ ctaLabel }}
      </button>

      <div class="tf-note">
        <i18n-t keypath="me.tfNote" tag="span" scope="global">
          <template #min>
            <b>{{ formatCentral(minTransfer) }}</b>
          </template>
        </i18n-t>
      </div>
    </AppDrawer>

    <!-- 场馆选择独立 Teleport，禁止嵌套在二级页 Teleport 内 -->
    <TransferVenueSheet
      v-model="sheetOpen"
      v-model:cat="catFilter"
      :selected="venueKey"
      :cats="cats"
      :venues="venues"
      :loading="listFetching"
      :cat-label="catLabel"
      :format-venue-amt="formatVenueAmt"
      @pick="onPickVenue"
    />
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()
const { open, closeTransfer } = useTransferNav()

const sheetOpen = ref(false)

const {
  dir,
  venueKey,
  venue,
  amount,
  auto,
  busy,
  settingsBusy,
  err,
  centralAvail,
  ctaLabel,
  amountSym,
  mainAcctLabel,
  minTransfer,
  formatCentral,
  formatVenueAmt,
  catLabel,
  catFilter,
  cats,
  venues,
  listFetching,
  listPending,
  swapDir,
  toggleAuto,
  setPct,
  pickVenue,
  submit,
} = useTransferForm()

watch(open, v => {
  if (!v) {
    sheetOpen.value = false
    catFilter.value = ''
  }
})

const onPickVenue = (k: string) => {
  if (pickVenue(k)) sheetOpen.value = false
}
</script>

<style scoped lang="scss">
.mt12 {
  margin-top: 12px;
}

.mt16 {
  margin-top: 16px;
}

.tf-err {
  color: #ffb84d;
  font-size: 12px;
  margin-top: 8px;
}

.tf-loading {
  margin-top: 12px;
  padding: 28px 12px;
  text-align: center;
  font-size: 13px;
  color: var(--muted);
}

.btn {
  display: block;
  width: 100%;
  border: 0;
  font-size: 15px;
  font-weight: 800;
  padding: 13px 16px;
  border-radius: var(--r-md);

  &:disabled {
    opacity: 0.55;
  }
}

.btn-primary {
  background: var(--primary);
  color: #fff;
  box-shadow: var(--btn-glow);
}

.btn-block {
  width: 100%;
}

.tf-note {
  margin-top: 12px;
  font-size: 12px;
  color: var(--muted);
  line-height: 1.7;

  b {
    color: var(--gold-hi, #ffd274);
  }
}
</style>
